import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { PAGES } from './shared/system-constants';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'CREATE BOOKING', url: '/' + PAGES.CREATE_LOAD, icon: 'construct' },
    { title: 'MANAGE BOOKINGS', url: '/' + PAGES.LIST_LOADS, icon: 'documents' },
    { title: 'SIGN OUT', url: '/' + PAGES.LOG_IN, icon: 'log-out' }
  ];

  constructor() {
    window.localStorage.setItem('currentTenant', environment.tenantCode);
  }

}
